import { useConnectivityStore } from '@/stores/connectivityStore';
import { useFirestore } from 'vuefire';
import { enableNetwork, disableNetwork } from 'firebase/firestore';

export default defineNuxtPlugin(() => {
  const connectivityStore = useConnectivityStore();
  const db = useFirestore();

  // Keep Firestore's network state in sync with connectivity. When offline,
  // disableNetwork() makes reads resolve immediately (from cache / empty)
  // instead of hanging, which is what makes the app feel buggy when opened
  // with no connection.
  const syncFirestore = async (online) => {
    try {
      if (online) {
        await enableNetwork(db);
      } else {
        await disableNetwork(db);
      }
    } catch (error) {
      console.error('Error syncing Firestore network state:', error);
    }
  };

  const handleOnline = () => {
    connectivityStore.setOnline(true);
    syncFirestore(true);
  };

  const handleOffline = () => {
    connectivityStore.setOnline(false);
    syncFirestore(false);
  };

  // Initialise from the current browser state.
  const initialOnline = navigator.onLine;
  connectivityStore.setOnline(initialOnline);
  if (!initialOnline) {
    syncFirestore(false);
  }

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
});
